import { c as _c } from "react/compiler-runtime";
import { addEventToDataLayer } from "@website/tracking/tracking.gtm";
import { DATA_LAYER_EVENTS, USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { daysBetweenDates } from "@website/utils/date-format";
import { useEffect } from "react";
interface Properties {
  isLoading: boolean;
  solutionsLength: number;
  dest: string;
  stDate: string;
  rtDate: string;
  source: string;
  search_source: string;
  roomsLength: number;
  calendar_type: string;
  totalCount: number;
  hasFilter: boolean;
  number_of_passengers: number;
}
export const usePageEvents = properties => {
  const $ = _c(32);
  const {
    isLoading,
    solutionsLength,
    dest,
    stDate,
    rtDate,
    source,
    search_source,
    roomsLength,
    calendar_type,
    totalCount,
    hasFilter,
    number_of_passengers
  } = properties;
  const pageLoadedFirstTime = Boolean(solutionsLength) || !isLoading && !solutionsLength;
  let t0;
  if ($[0] !== calendar_type || $[1] !== dest || $[2] !== hasFilter || $[3] !== number_of_passengers || $[4] !== roomsLength || $[5] !== rtDate || $[6] !== search_source || $[7] !== solutionsLength || $[8] !== source || $[9] !== stDate || $[10] !== totalCount) {
    t0 = () => {
      if (solutionsLength) {
        addEventToTracking(USER_TRACKING_EVENTS.SEARCH_RESULTS_PAGE_VISITED, {
          product: "tour",
          origin_city: origin,
          destination_city: dest,
          departure_date: new Date(stDate),
          return_departure_date: new Date(rtDate),
          number_of_passengers,
          number_of_rooms: roomsLength,
          search_source: search_source || source,
          calendar_type,
          search_window: Math.abs(daysBetweenDates(new Date(), stDate)),
          number_of_results: totalCount,
          tour_has_filters: hasFilter
        });
      }
    };
    $[0] = calendar_type;
    $[1] = dest;
    $[2] = hasFilter;
    $[3] = number_of_passengers;
    $[4] = roomsLength;
    $[5] = rtDate;
    $[6] = search_source;
    $[7] = solutionsLength;
    $[8] = source;
    $[9] = stDate;
    $[10] = totalCount;
    $[11] = t0;
  } else {
    t0 = $[11];
  }
  let t1;
  if ($[12] !== hasFilter || $[13] !== number_of_passengers || $[14] !== pageLoadedFirstTime || $[15] !== roomsLength || $[16] !== rtDate || $[17] !== stDate) {
    t1 = [pageLoadedFirstTime, hasFilter, rtDate, stDate, number_of_passengers, roomsLength];
    $[12] = hasFilter;
    $[13] = number_of_passengers;
    $[14] = pageLoadedFirstTime;
    $[15] = roomsLength;
    $[16] = rtDate;
    $[17] = stDate;
    $[18] = t1;
  } else {
    t1 = $[18];
  }
  useEffect(t0, t1);
  let t2;
  if ($[19] !== dest || $[20] !== number_of_passengers || $[21] !== rtDate || $[22] !== search_source || $[23] !== solutionsLength || $[24] !== source || $[25] !== stDate) {
    t2 = () => {
      addEventToDataLayer(DATA_LAYER_EVENTS.FLIGHTS_INTL_SEARCH_RESULTS_PAGE_VISITED, {
        item_brand: "tour",
        item_name: `${origin} - ${dest}`,
        destination_city: dest,
        departure_date: stDate,
        origin_city: origin,
        number_of_passengers,
        search_window: Math.abs(daysBetweenDates(new Date(), stDate)),
        return_date: rtDate,
        search_source: search_source || source,
        nightstay: daysBetweenDates(stDate, rtDate),
        number_of_results: solutionsLength
      });
    };
    $[19] = dest;
    $[20] = number_of_passengers;
    $[21] = rtDate;
    $[22] = search_source;
    $[23] = solutionsLength;
    $[24] = source;
    $[25] = stDate;
    $[26] = t2;
  } else {
    t2 = $[26];
  }
  let t3;
  if ($[27] !== number_of_passengers || $[28] !== pageLoadedFirstTime || $[29] !== rtDate || $[30] !== stDate) {
    t3 = [pageLoadedFirstTime, rtDate, stDate, number_of_passengers];
    $[27] = number_of_passengers;
    $[28] = pageLoadedFirstTime;
    $[29] = rtDate;
    $[30] = stDate;
    $[31] = t3;
  } else {
    t3 = $[31];
  }
  useEffect(t2, t3);
};